import { render, staticRenderFns } from "./yxAd.vue?vue&type=template&id=4e0d3f57&"
import script from "./yxAd.vue?vue&type=script&lang=js&"
export * from "./yxAd.vue?vue&type=script&lang=js&"
import style0 from "./yxAd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports